// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__3xHc5","footer":"ModalFilter_footer__1Uwiv"};